import { InjectionToken } from "@angular/core";

export const APP_CONFIG_TOKEN = new InjectionToken<AppConfig>("CONFIG");

export interface AppConfig {
	/* application name */
	readonly app: string;
	/* tm-server api base url */
	readonly apiUrl: string;
	/* SAP API base url */
	readonly sapApiUrl: string;
	/* language locale */
	locale: string;
	/* flag for production or development environment */
	readonly production: boolean;
	/* version (from package.json) */
	readonly version: string;
	/* version with attached build info (commit hash) */
	readonly versionLabel: string;
	/* dsn of related sentry project */
	readonly sentryDSN: string;
}
